import { composeStructuredAddress } from './structuredAddressModel';
import { validPin } from './addressLocationModel';

export const normalizeAddressForEditor = (address) => {
  if (!address || typeof address !== "object") return address;
  if (typeof address.pref_time !== "string") return address;
  try {
    const parsed = JSON.parse(address.pref_time);
    return Array.isArray(parsed) ? { ...address, pref_time: parsed } : address;
  } catch {
    return address;
  }
};

export const buildCustomerSavePayload = (customer, draft) => {
  const payload = { customer_id: customer.customer_id };
  if (draft.customer_name !== (customer.customer_name || "")) payload.customer_name = draft.customer_name;
  if (draft.customer_real_name !== (customer.customer_real_name || "")) payload.customer_real_name = draft.customer_real_name;
  if (draft.customer_email !== (customer.customer_email || "")) payload.customer_email = draft.customer_email;
  // Historically read-only — WATI guaranteed a phone number always existed.
  // Now some WATI contacts hide it entirely (username-only), so staff need
  // to add/correct it manually. Send null on a deliberate clear, not "".
  if ((draft.customer_mobile || "").trim() !== (customer.customer_mobile || "")) {
    payload.customer_mobile = (draft.customer_mobile || "").trim() || null;
  }
  if ((draft.status ? 1 : 0) !== (customer.status ? 1 : 0)) payload.status = draft.status ? 1 : 0;
  if (draft.type !== (customer.type ?? null)) payload.type = draft.type;

  return payload;
};

export function buildAddressSavePayload(subForm) {
  const pinned = validPin(subForm.latitude, subForm.longitude);
  const trimmed = key => String(subForm[key] ?? '').trim() || null;
  return {
    address_format: 'structured',
    name: trimmed('name'),
    type: subForm.type || null,
    number: String(subForm.number ?? '').replace(/\D/g, '') || null,
    address: composeStructuredAddress(subForm),
    pref_time: Array.isArray(subForm.pref_time)
      ? JSON.stringify(subForm.pref_time)
      : subForm.pref_time ?? null,
    latitude: pinned ? Number(subForm.latitude) : null,
    longitude: pinned ? Number(subForm.longitude) : null,
    note: subForm.note ?? null,
    delivery_mode: 'own',
    location_source: pinned ? (['search', 'pin', 'chat', 'link'].includes(subForm.location_source) ? subForm.location_source : 'pin') : 'none',
    no_pin_reason: pinned ? null : trimmed('no_pin_reason'),
    no_pin_note: !pinned && subForm.no_pin_reason === 'other' ? trimmed('no_pin_note') : null,
    details: trimmed('details'), country_code: trimmed('country_code'), region: trimmed('region'),
    unit_no: trimmed('unit_no'), building: trimmed('building'), street: trimmed('street'),
    area: trimmed('area'), city: trimmed('city'), landmark: trimmed('landmark'), map_address: trimmed('map_address'),
  };
}
